"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var react_1 = __importDefault(require("react"));
var SidebarHoverButton_1 = __importDefault(require("./components/SidebarHoverButton"));
var SidebarToggleButton_1 = __importDefault(require("./components/SidebarToggleButton"));
var SidebarButton = react_1.default.forwardRef(function (_a, ref) {
    var type = _a.type, id = _a.id, props = __rest(_a, ["type", "id"]);
    var buttonId = react_1.default.useRef(id || uniqueId_1.default("sidebar-button-"));
    switch (type) {
        case "hover":
            return (react_1.default.createElement(SidebarHoverButton_1.default, __assign({ id: buttonId.current, ref: ref }, props)));
        case "toggle":
            return (react_1.default.createElement(SidebarToggleButton_1.default, __assign({ id: buttonId.current, ref: ref }, props)));
        default:
            return null;
    }
});
SidebarButton.displayName = "SidebarButton";
SidebarButton.defaultProps = {
    type: "hover"
};
exports.default = SidebarButton;
//# sourceMappingURL=index.js.map